import React from 'react';

import { OptimisticPublicationDate } from '@/components/_common/optimistic-publication-date';

import { useHeaderContext } from '../../../context';

import * as S from './published-date.styles';

export const PublishedDate: React.FC = () => {
  const { publishedDate } = useHeaderContext();

  return !publishedDate ? null : (
    <S.TextRow size="small" data-testid="published-date">
      <OptimisticPublicationDate date={publishedDate} />
    </S.TextRow>
  );
};
